<template>
  <div>
    <p class="lead d-flex justify-content-between">
      <span>Restaurar tipo de alarma</span>
      <span class="small">{{ action.data.timestamp }}</span>
    </p>
    <div class="cmd-card">
      <div class="cmd-card__header">
        <span class="cmd-card__icon">
          <feather-icon icon="PlayCircleIcon" size="16"/>
        </span>
        <span class="cmd-card__name">
          Restaurar tipo de alarma
        </span>

        <b-button
          variant="primary"
          size="sm"
          @click="onExecuteCmdClick(action)"
          :disabled="terminated"
          v-if="!action.data.executed"
        >
          <feather-icon icon="PlayCircleIcon" size="18" class="mr-25"/>
          {{ $t("action_plan.viewer.execute") }}
        </b-button>

        <!-- Command status ok -->
        <span class="cmd-card__status cmd-card__status--success"
              v-if="action.data.executed && action.data.status === 'OK'">
          <feather-icon icon="CheckCircleIcon" size="14" class="mr-25"/>
          {{ $t("action_plan.viewer.executed_success") }}
        </span>

        <!-- Command status error -->
        <span class="cmd-card__status cmd-card__status--error"
              v-if="action.data.executed && action.data.status === 'ERROR'">
          <feather-icon icon="XCircleIcon" size="14" class="mr-25"/>
          {{ $t("action_plan.viewer.executed_error") }}
        </span>
      </div>
    </div>
    <div class="my-1">
      <label :for="`input-${action.id}`">
        {{ $t("action_plan.viewer.comments") }}
      </label>
      <input
        type="text"
        :id="`input-${action.id}`"
        v-model="action.data.comments"
        class="form-control"
        :placeholder="$t('action_plan.viewer.comments')"
        :disabled="terminated || validating"
      />
    </div>
    <div class="my-1">
      <files
        v-model="action.data.files"
        :action-plan-log-uuid="actionPlanLogUuid"
        :validating="validating"
        :preview="preview"
        :terminated="terminated"
        :action="action"
        @file-added="$emit('checkpoint')"
      />
    </div>

    <div class="text-right mb-1">
      <template v-if="!action.node_data.required">
        <b-button
          variant="primary"
          size="sm"
          @click="onContinueClick(action)"
          :disabled="validating"
          v-if="!action.data.continue && !terminated"
        >
          {{ $t("action_plan.viewer.continue") }}
          <feather-icon icon="ChevronRightIcon" size="18"/>
        </b-button>
      </template>
      <template v-else>
        <b-button
          variant="primary"
          size="sm"
          @click="onContinueClick(action)"
          :disabled="!action.data.executed || validating"
          v-if="!action.data.continue && !terminated"
        >
          {{ $t("action_plan.viewer.continue") }}
          <feather-icon icon="ChevronRightIcon" size="18"/>
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
import commandStackHelperMixin from "@/mixins/commandStackHelperMixin";
import axios from "@axios";
import Files from "./Files.vue"

export default {
  components: {Files},
  mixins: [commandStackHelperMixin],
  props: {
    actionPlanLogUuid: String,
    alarmId: String | Number,
    action: Object,
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  methods: {
    onContinueClick(action) {
      this.$emit("continue", action);
    },
    async onExecuteCmdClick(action) {
      if (!this.preview) {
        const data = {
          action_plan_log_id: this.actionPlanLogUuid,
          id_alarm: this.alarmId,
        };
        try {
          await axios.post("/v1/action_plan/restore-alarm-type", data);
          this.$set(action.data, "executed", true);
          this.$set(action.data, "status", "OK");
        } catch (error) {
          this.$set(action.data, "executed", true);
          this.$set(action.data, "status", "ERROR");
        }
      } else {
        this.$set(action.data, "executed", true);
        this.$set(action.data, "status", "OK");
      }
    },
    resolveNodeName(nodeData) {
      return nodeData.cmd !== "custom"
        ? this.$t(`commands.list.${nodeData.cmd_name}.name`)
        : nodeData.cmd_name;
    },
  },
};
</script>

<style scoped>
.entity-link {
  cursor: pointer;
  color: #0052cc;
  text-decoration: none;
}

.entity-link:hover {
  text-decoration: underline;
}

.cursor-pointer {
  cursor: pointer;
}

.cmd-card {
  margin-bottom: 0.5rem;
  padding: 0.65rem 0.9rem;
  background-color: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 0.5rem;
}

.cmd-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
}

.cmd-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(27, 61, 94, 0.08);
  color: #1b3d5e;
}

.cmd-card__name {
  flex: 1 1 auto;
  min-width: 120px;
  font-weight: 600;
  color: #5e5873;
}

.cmd-card__meta {
  font-size: 0.85rem;
  color: #a5a2ad;
}

.cmd-card__status {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0.3rem 0.75rem;
  border-radius: 2rem;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.4;
}

.cmd-card__status--success {
  background-color: rgba(40, 199, 111, 0.12);
  color: #1f9d57;
}

.cmd-card__status--error {
  background-color: rgba(234, 84, 85, 0.12);
  color: #d43b3c;
}

.cmd-card__body {
  margin-top: 0.6rem;
  padding: 0.6rem 0 0 2.4rem;
  border-top: 1px solid #ebe9f1;
  color: #6e6b7b;
}

.dark-layout .cmd-card {
  background-color: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.08);
}

.dark-layout .cmd-card__icon {
  background-color: rgba(255, 255, 255, 0.08);
  color: #d0d2d6;
}

.dark-layout .cmd-card__name {
  color: #d0d2d6;
}

.dark-layout .cmd-card__meta {
  color: #8a91a5;
}

.dark-layout .cmd-card__status--success {
  background-color: rgba(40, 199, 111, 0.18);
  color: #63e6a5;
}

.dark-layout .cmd-card__status--error {
  background-color: rgba(234, 84, 85, 0.18);
  color: #f5a3a4;
}

.dark-layout .cmd-card__body {
  border-top-color: rgba(255, 255, 255, 0.08);
  color: #b4b7bd;
}
</style>
